export const PRIMARY_LOCATION = "PRIMARY";
export const FOOTER_1 = "FOOTER_COLUMN_1";
export const FOOTER_2 = "FOOTER_COLUMN_2";
export const FOOTER_3 = "FOOTER_COLUMN_3";
export const FOOTER_4 = "FOOTER_COLUMN_4";
